import { request } from '../../request';

export const brandsFetch = () => {
	return request({ url: '/shop/brands' });
};

export const brandsForItemsFetch = (id: number | undefined) => {
	return request({ url: `/shop/category/${id}/brands` });
};
